import AwLovEdit from 'viewmodel/AwLovEditViewModel';
import _ from 'lodash';
import appCtxSvc from 'js/appCtxService';
const propsField = ['displayValue', 'uiValue', 'value', 'uiValues', 'displayValues', 'newDisplayValues'];
const DISPLAY_VALUE = 'vmo.props.value.displayValue';

/**
 * render function for AwLovEdit
 * @param {*} param0 context for render function interpolation
 * @returns {JSX.Element} react component
 */

export const awCustomLOVComponentRenderFunction = (props) => {

    const { viewModel, ...prop } = props;
    const isTouched = _.get(prop, 'touched');
    if (isTouched !== 'false' || isTouched === 'true' || isTouched === true) {
        appCtxSvc.registerCtx('loadLovUsingAPI', true);
        const fielddata = { ...prop.fielddata };
        fielddata.hasLov = true;
        fielddata.isSelectOnly = true;
        fielddata.dataProvider = viewModel.dataProviders.featureValuesProvider;
        fielddata.displayValues = [prop.value];
        _.set(prop, DISPLAY_VALUE, prop.value);
        _.set(prop, 'vmo.props.value.uiValue', prop.value);
        _.set(prop, 'vmo.props.value.value', prop.value);
        _.set(prop, 'vmo.props.value.uiValues', [prop.value]);
        _.set(prop, 'vmo.props.value.displayValues', [prop.value]);
        _.set(prop, 'vmo.props.value.newDisplayValues', [prop.value]);
        const passedProps = { ...prop, fielddata };
        return (
            <AwLovEdit {...passedProps} ></AwLovEdit>
        );
    } else {
        const fielddata = { ...prop.fielddata };
        fielddata.hasLov = true;
        fielddata.isSelectOnly = true;
        fielddata.dataProvider = viewModel.dataProviders.featureValuesProvider;
        const displayValue = _.get(prop, DISPLAY_VALUE, _.get(prop, 'vmo.props.value.dbValue'));
        _.set(prop, 'value', displayValue);
        _.set(fielddata, 'displayValues', [displayValue]);
        _.set(fielddata, 'uiValue', displayValue);
        _.set(fielddata, 'uiValues', [displayValue]);
        // g
        _.set(prop, DISPLAY_VALUE, displayValue);
        _.set(prop, 'vmo.props.value.uiValue', displayValue);
        _.set(prop, 'vmo.props.value.value', displayValue);
        _.set(prop, 'vmo.props.value.uiValues', [displayValue]);
        _.set(prop, 'vmo.props.value.displayValues', [displayValue]);
        _.set(prop, 'vmo.props.value.newDisplayValues', [displayValue]);

        const passedProps = { ...prop, fielddata };
        return (
            <AwLovEdit {...passedProps} ></AwLovEdit>
        );
    }
};


import accHttpSvr from 'js/accHttpService';
const loadLovs = async (data, ctx) => {
    try {
        const request = {
            method: 'POST',
            url: '/acc/orchestrate',
            withCredentials: true,
            data: {
                additionalProperties: {
                    "catalogspaceId": data.catalogspaceId,
                    "feature": ctx.feature
                },
                "query": "query GetFeatureGroup($getFeatureGroupInput: GetFeatureGroupInput) { getFeatureGroup (getFeatureGroupInput: $getFeatureGroupInput) }",
                "variables": {
                    "getFeatureGroupInput": {
                        "featureGroupId": ctx.featureGroupId,
                        "provider": data.provider
                    }
                }
            }
        };

        return accHttpSvr.createHttpRequest(request, 'catalog', data.accsessionid);
    } catch (err) {
        console.log('error inside makehttp call', err);
        throw err;
    }
}
export const desLoadLovs = async (props, ctx, data) => {
    const allLov = _.get(props, 'vmo.featureGroups', []);
    let featureGroupItems = [];
    if (allLov.length > 0) {
        featureGroupItems = allLov;
    } else {
        const apiRes = await loadLovs(data, ctx);
        featureGroupItems = _.get(apiRes, 'data.data.getFeatureGroup.items');
    }
    return {
        featureGroupItems: featureGroupItems
    };
}
